import { StatTile } from '@/components/ui/stat-tile';
import { translate } from '../../../../utils/Common';

// Paquetes por entregar en boxit
const PackagesWaitingDelivery = ({ cantPackagesDelivery, cardTitle, tooltipMessage }) => (
    <StatTile
        loading={!(cantPackagesDelivery || cantPackagesDelivery === 0)}
        value={cantPackagesDelivery}
        label={cardTitle || translate("dashboard.home.packages_waiting.title")}
        info={
            tooltipMessage ||
            translate("dashboard.home.packages_waiting.info_1") +
            translate("dashboard.home.packages_waiting.info_2") +
            translate("dashboard.home.packages_waiting.info_3")
        }
    />
);

export default PackagesWaitingDelivery;
